import { render, staticRenderFns } from "./PeriodoComponent.vue?vue&type=template&id=72a8d864"
import script from "./PeriodoComponent.vue?vue&type=script&lang=js"
export * from "./PeriodoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports